import { unitMeasurementOptionsTranslation } from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import {
  componentDefinitionDiscriminatorTypeDescriptions,
  componentDefinitionDiscriminatorTypeOptions,
  componentDefinitionTypeOptions,
  ComponentDefinitionTypeOptions,
  ComponentDefinitionUnitMeasurementOptions,
  DiscriminatorTypeOptions,
} from '@/assets/locales/views/componentDefinitions/componentDefinitions.common.translation.pl.ts';
import { ComponentDefinitionDialogModel } from '@/views/componentDefinitions/list/components/dialog/model/ComponentDefinitionDialog.model.ts';
import { ComponentDefinitionsSearchFormModel } from '@/views/componentDefinitions/list/model/ComponentDefinitionsSearchForm.model.ts';

export type ComponentDefinitionsListTranslation = {
  dialog: {
    button: {
      cancel: string;
      save: string;
      saveAndAdd: string;
    };
    form: Record<keyof ComponentDefinitionDialogModel, string> & {
      componentDefinitionType: ComponentDefinitionTypeOptions;
      discriminatorHelp: string;
      discriminatorTypeDescriptions: DiscriminatorTypeOptions;
      discriminatorTypeOptions: DiscriminatorTypeOptions;
      unitMeasurement: ComponentDefinitionUnitMeasurementOptions;
    };
    title: {
      create: string;
    };
  };
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: Record<'active' | 'createdAt' | 'discriminatorType' | 'name' | 'type', string> & {
      componentDefinitionType: ComponentDefinitionTypeOptions;
      discriminatorTypeOptions: DiscriminatorTypeOptions;
    };
    head: Record<keyof ComponentDefinitionsSearchFormModel, string> & {
      componentDefinitionType: ComponentDefinitionTypeOptions;
    };
  };
};

export const componentDefinitionsListTranslation: ComponentDefinitionsListTranslation = {
  dialog: {
    button: {
      cancel: 'Anuluj',
      save: 'Zapisz',
      saveAndAdd: 'Zapisz i dodaj kolejny',
    },
    form: {
      active: 'Aktywny',
      componentDefinitionType: componentDefinitionTypeOptions,
      componentType: 'Typ komponentu',
      discriminator: 'Rodzaj',
      discriminatorHelp: 'Wybierz rodzaj, aby zobaczyć opis i przykłady zastosowania.',
      discriminatorTypeDescriptions: componentDefinitionDiscriminatorTypeDescriptions,
      discriminatorTypeOptions: componentDefinitionDiscriminatorTypeOptions,
      name: 'Nazwa',
      type: 'Typ',
      unit: 'Jednostka',
      unitMeasurement: unitMeasurementOptionsTranslation,
    },
    title: {
      create: 'Dodaj nowy element oferty',
    },
  },
  header: {
    button: {
      add: 'Dodaj',
    },
  },
  table: {
    body: {
      active: 'Aktywny',
      componentDefinitionType: componentDefinitionTypeOptions,
      createdAt: 'Data utworzenia',
      discriminatorType: 'Typ',
      discriminatorTypeOptions: componentDefinitionDiscriminatorTypeOptions,
      name: 'Nazwa',
      type: 'Typ elementu',
    },
    head: {
      active: 'Aktywny',
      componentDefinitionType: componentDefinitionTypeOptions,
      componentTypeId: 'Typ komponentu',
      discriminator: 'Rodzaj',
      fullTextSearchInput: 'Wyszukaj',
      type: 'Typ',
    },
  },
};
